import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { hash } from 'rsvp';

const SORT_COL_TO_FIELD_NAME = {
  Host: 'host',
  'Signed in': 'finalized_at',
  Name: 'full_name',
  Location: 'locations.name',
};

const ORDER_DESC_VALS = ['Z-A', 'Most to least recent'];
const PAGE_SIZE = 30;

export default class MyLocationsVisitorLog extends Route {
  @service abilities;
  @service currentLocation;
  @service router;
  @service store;

  queryParams = {
    pageNumber: {
      refreshModel: true,
    },
    pageSize: {
      refreshModel: true,
    },
    sortBy: {
      refreshModel: true,
    },
    sortDirection: {
      refreshModel: true,
    },
    query: {
      refreshModel: true,
    },
    locationIds: {
      refreshModel: true,
    },
    signedOut: {
      refreshModel: true,
    },
    startDate: {
      refreshModel: true,
    },
    endDate: {
      refreshModel: true,
    },
  };

  beforeModel() {
    if (this.abilities.cannot('visit my-locations')) {
      this.router.transitionTo('unauthorized');
    }
  }

  model({ endDate, locationIds, pageNumber, query, signedOut, sortBy, sortDirection, startDate }) {
    const params = {};
    const offset = PAGE_SIZE * pageNumber - PAGE_SIZE;
    const store = this.store;
    const orderDescending = ORDER_DESC_VALS.includes(sortDirection);
    const sortOrder = orderDescending ? '-' : '';
    const sortProp = SORT_COL_TO_FIELD_NAME[sortBy];

    if (sortBy) {
      params.sort = `${sortOrder}${sortProp}`;
    }

    params.filter = {};

    if (query) {
      params.filter.query = query;
    }

    if (startDate) {
      params.filter.startDate = startDate;
    }

    if (endDate) {
      params.filter.endDate = endDate;
    }

    params.page = { offset, size: PAGE_SIZE, limit: PAGE_SIZE };

    if (locationIds) {
      params.filter.location = locationIds;
    }

    if (signedOut) {
      params.filter.status = signedOut;
    }

    return hash({ entries: store.query('entry', params), params });
  }

  @action
  loading(transition, _originRoute) {
    const controller = this.controllerFor('my-locations/visitor-log');
    controller.loadingData = true;
    transition.promise.finally(function () {
      controller.loadingData = false;
    });
  }
}
